import ReactModal from 'react-modal';

const ModalConfig = () => {
  ReactModal.defaultStyles.overlay.backgroundColor = false;
  ReactModal.setAppElement('#root');
};

export default ModalConfig;
